import { featuredPersonas, type Persona } from "@/mocks/homeData";

function PersonaCard({ item }: { item: Persona }) {
  return (
    <article className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-background-300 hover:bg-background-100/60 md:p-6">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <span
            className={`grid h-11 w-11 shrink-0 place-items-center rounded-full font-heading text-base font-black ${
              item.hot ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-800"
            }`}
          >
            {item.initials}
          </span>
          <div>
            <p className="text-sm font-bold text-foreground-950">{item.handle}</p>
            <p className="mt-0.5 text-xs text-foreground-600">{item.zone}</p>
          </div>
        </div>
        <span
          className={`inline-flex h-6 shrink-0 items-center rounded-full px-2.5 text-xs font-medium ${
            item.status === "续料中" ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-900"
          }`}
        >
          <i className={`mr-1 text-xs leading-none ${item.status === "续料中" ? "ri-loader-4-line" : "ri-check-double-line"}`} />
          {item.status}
        </span>
      </div>

      <h3 className="mt-5 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
        <a href="#comments" className="transition-colors group-hover:text-primary-600 cursor-pointer">
          {item.title}
        </a>
      </h3>
      <p className="mt-3 flex-1 text-sm leading-6 text-foreground-700">{item.desc}</p>

      <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
          <i className="ri-price-tag-3-line text-xs leading-none" />
          {item.tag}
        </span>
        <div className="flex items-center gap-4 text-xs text-foreground-600">
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-primary-500 text-sm" />
            {item.heat}
          </span>
          <a href="#comments" className="inline-flex items-center gap-1 whitespace-nowrap cursor-pointer hover:text-primary-600">
            <i className="ri-chat-3-line text-sm" />
            {item.comments}
          </a>
        </div>
      </div>
    </article>
  );
}

export default function FeaturedGrid() {
  return (
    <section id="featured" className="scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Featured / 头条人物</p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              谁有瓜，先点谁
            </h2>
          </div>
          <a href="#dossier" className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 hover:text-foreground-950 sm:inline-flex cursor-pointer">
            进完整目录
            <i className="ri-arrow-right-line text-base leading-none" />
          </a>
        </div>
        <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
          每条都是一个人物的独立旧账主页，进度与评论区随时续。今天这四位在争议榜上热度最高。
        </p>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featuredPersonas.map((item) => (
            <PersonaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}